// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBar_form__qBdjT","input":"SearchBar_input__35An9","searchBtn":"SearchBar_searchBtn__2KO81"};